<c-sidebar
  #aside1="cSidebar"
  class="d-print-none hide border-start"
  colorScheme="light"
  id="aside1"
  overlaid
  placement="end"
  size="lg"
>
  <c-tabs activeItemKey="0">
    <c-sidebar-header class="bg-transparent p-0 position-relative">
      <!--nav for tabs-->
      <c-tabs-list class="w-100" variant="underline-border">
        <button aria-label="Open schedule tab" cTab itemKey="0">
          <i class="bi bi-list-ul" aria-label="Schedule"></i>
        </button>
        <!-- <button aria-label="Open messages tab" cTab itemKey="1">
          <i class="bi bi-chat-dots" aria-label="Messages"></i>
        </button> -->
        <!-- <button aria-label="Open settings tab" cTab itemKey="2">
          <i class="bi bi-gear" aria-label="Settings"></i>
        </button> -->
        <button
          aria-label="Close aside"
          cButtonClose
          cSidebarToggle="aside1"
          class="end-0 my-0 top-50 position-absolute translate-middle"
          toggle="visible"
        ></button>
      </c-tabs-list>
    </c-sidebar-header>

    <!--tab content-->
    <c-tabs-content>
      <c-tab-panel itemKey="0" class="overflow-auto" style="max-height: calc(100vh - 150px);">
        <ng-container *ngTemplateOutlet="tabPane0" />
      </c-tab-panel>
      <!-- <c-tab-panel class="p-2" itemKey="1">
        <ng-container *ngTemplateOutlet="tabPane1" />
      </c-tab-panel> -->
      <!-- <c-tab-panel class="p-3" itemKey="2">
        <ng-container *ngTemplateOutlet="tabPane2" />
      </c-tab-panel> -->
    </c-tabs-content>
  </c-tabs>
</c-sidebar>

<!--tab pane templates-->
<ng-template #tabPane0>
  <div [flush]="true" cListGroup>
    <a [cBorder]="{ start: { color: 'success', width: 4 } }" cListGroupItem class="d-flex justify-content-between align-items-center bg-success bg-opacity-25 border-top-0">
      <span class="fw-semibold text-body-secondary text-uppercase small">Active Notes - {{ currentFilters?.startDate ? ' (' + (currentFilters.startDate | date:'MM/dd') + '-' + (currentFilters.endDate | date:'MM/dd') + ') ' : currentFilters?.group || 'All' }}</span>
      @if (currentFilters?.mode !== 'disableNoteCreation') {
        <button class="btn btn-sm btn-outline-primary" (click)="addNewNote()" title="Add new note">
          <i class="bi bi-plus"></i>
        </button>
      }
    </a>
    
    <!-- Draft Note Component - only shown when draftNote exists -->
    <!-- @if (draftNote) {
      <a [cBorder]="{ start: { color: 'primary', width: 4 } }" [routerLink]="[]" cListGroupItem>
        <div>
          <input type="text" class="form-control form-control-sm" 
                 [(ngModel)]="draftNote.description" 
                 #draftInput
                 (blur)="saveNote(draftNote, draftInput.value)"
                 (keydown.enter)="saveNote(draftNote, draftInput.value)"
                 (keydown.escape)="cancelEdit(draftNote)"
                 placeholder="Enter new note..."
                 autofocus>
        </div>
        <div class="d-flex justify-content-between align-items-center">
          <small class="text-body-secondary" style="font-size: 0.75rem;">
            New Note
          </small>
          <div class="d-flex align-items-center">
            <small class="text-primary me-2" style="font-size: 0.8rem; font-weight: 600;">DRAFT</small>
            <div class="form-check form-switch" (click)="$event.stopPropagation()">
              <input class="form-check-input" 
                     type="checkbox" 
                     role="switch" 
                     checked
                     disabled
                     title="Cannot close draft note">
            </div>
          </div>
        </div>
      </a>
    } -->
    
    @for (note of activeNotes; track note.id; let i = $index) {
      <a [cBorder]="{ start: { color: 'success', width: 4 } }" [routerLink]="[]" cListGroupItem>
        <div>
          @if (note.isEditing) {
            <input type="text" class="form-control form-control-sm" 
                   [(ngModel)]="note.description" 
                   (blur)="saveNote(note)"
                   (keydown.enter)="saveNote(note)"
                   (keydown.escape)="cancelEdit(note)"
                    app-autoFocus>
          } @else {
            <strong (click)="startEdit(note)" style="cursor: pointer;">{{ note.description }}</strong>
          }
        </div>
        <div class="d-flex justify-content-between align-items-center">
          <small class="text-body-secondary" style="font-size: 0.75rem;">
            <!-- <i class="bi bi-calendar"></i> -->
            Open: {{ note.startDate | date:'MM/dd' }}
          </small>
          <div class="d-flex align-items-center">
            <small class="text-success me-2" style="font-size: 0.8rem; font-weight: 600;">ON</small>
            <div class="form-check form-switch" (click)="$event.stopPropagation()">
              <input class="form-check-input" 
                     type="checkbox" 
                     role="switch" 
                     [checked]="note.endDate === null"
                     [disabled]="!note.id"
                     (change)="onNoteCloseChange(note, $event)">
            </div>
          </div>
        </div>
      </a>
    } @empty {
      <a cListGroupItem class="text-center text-muted py-3">
        <small class="fst-italic">No Active Notes Yet</small>
      </a>
    }
    <a [cBorder]="{ start: { color: 'secondary', width: 4 } }" cListGroupItem class="list-group-item list-group-item border-start-4 border-start-secondary bg-danger bg-opacity-25 text-center fw-semibold text-body-secondary text-uppercase small">
      Closed Notes - {{ currentFilters?.startDate ? ' (' + (currentFilters.startDate | date:'MM/dd') + '-' + (currentFilters.endDate | date:'MM/dd') + ') ' : 'All' }}
    </a>
    @for (note of closedNotes; track note.id; let i = $index) {
      <a [cBorder]="{ start: { color: 'danger', width: 4 } }" [routerLink]="[]" cListGroupItem>
        <div>
          @if (note.isEditing) {
            <input type="text" class="form-control form-control-sm" 
                   [(ngModel)]="note.description" 
                   (blur)="saveNote(note)"
                   (keydown.enter)="saveNote(note)"
                   (keydown.escape)="cancelEdit(note)"
                    app-autoFocus>
          } @else {
            <strong (click)="startEdit(note)" style="cursor: pointer;">{{ note.description }}</strong>
          }
        </div>
        <div class="d-flex justify-content-between align-items-center">
          <small class="text-body-secondary me-3" style="font-size: 0.75rem;">
            <!-- <i class="bi bi-calendar-range"></i> -->
            from: {{ note.startDate | date:'MM/dd' }} to {{ note.endDate | date:'MM/dd' }}
          </small>
          <div class="d-flex align-items-center">
            <small class="text-danger me-2" style="font-size: 0.80rem; font-weight: 600;">OFF</small>
            <div class="form-check form-switch" (click)="$event.stopPropagation()">
              <input class="form-check-input" 
                     type="checkbox" 
                     role="switch" 
                     [checked]="note.endDate === null"
                     (change)="onNoteCloseChange(note, $event)">
            </div>
          </div>
        </div>
      </a>
    } @empty {
      <a cListGroupItem class="text-center text-muted py-3">
        <small class="fst-italic">No Closed Notes Yet</small>
      </a>
    }
  </div>
</ng-template>

<!-- <ng-template #tabPane1>
  <div [flush]="true" cListGroup>
    @for (message of messages; track message; let i = $index, last = $last) {
      <a
        [cBorder]="{ bottom: last ? 0 : 1 }"
        [routerLink]="'/apps/email/message'"
        cListGroupItem
        class="message"
      >
        <div class="py-3 pb-5 me-3 float-start">
          <c-avatar
            size="md"
            src="./assets/img/avatars/avatar.jpg"
            status="success"
          />
        </div>
        <div>
          <small class="text-body-secondary">Lukasz Holeczek</small>
          <small class="text-body-secondary float-end mt-1">1:52 PM</small>
        </div>
        <div class="text-truncate fw-semibold">
          Lorem ipsum dolor sit amet
        </div>
        <small class="text-body-secondary">
          Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do
          eiusmod tempor incididunt...
        </small>
      </a>
    }
  </div>
</ng-template> -->

<!-- <ng-template #tabPane2>
  <h6>Settings</h6>
  <div>
    <div class="clearfix mt-4">
      <c-form-check [switch]="true" sizing="lg">
        <input cFormCheckInput checked id="Option1" type="checkbox" />
        <label cFormCheckLabel>Option 1</label>
      </c-form-check>
    </div>
    <div>
      <small class="text-body-secondary">
        Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do
        eiusmod tempor incididunt ut labore et dolore magna aliqua.
      </small>
    </div>
  </div>
  <div>
    <div class="clearfix mt-3">
      <c-form-check [switch]="true" sizing="lg">
        <input cFormCheckInput id="Option2" type="checkbox" />
        <label cFormCheckLabel>Option 2</label>
      </c-form-check>
    </div>
    <div>
      <small class="text-body-secondary">
        Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do
        eiusmod tempor incididunt ut labore et dolore magna aliqua.
      </small>
    </div>
  </div>
  <div>
    <div class="clearfix mt-3">
      <c-form-check [switch]="true" sizing="lg">
        <input cFormCheckInput id="Option3" type="checkbox" />
        <label cFormCheckLabel>Option 3</label>
      </c-form-check>
    </div>
  </div>
  <div>
    <div class="clearfix mt-3">
      <c-form-check [switch]="true" sizing="lg">
        <input cFormCheckInput checked id="Option4" type="checkbox" />
        <label cFormCheckLabel>Option 4</label>
      </c-form-check>
    </div>
  </div>
  <hr />
  <h6>System Utilization</h6>
  <div class="text-uppercase small fw-semibold mb-1 mt-4">
    CPU Usage
  </div>
  <c-progress [value]="25" color="info-gradient" thin />
  <small class="small text-body-secondary">348 Processes. 1/4 Cores.</small>
  <div class="text-uppercase small fw-semibold mb-1 mt-2">
    Memory Usage
  </div>
  <c-progress [value]="70" color="warning-gradient" thin />
  <small class="small text-body-secondary">11444GB/16384MB</small>
  <div class="text-uppercase small fw-semibold mb-1 mt-2">
    SSD 1 Usage
  </div>
  <c-progress [value]="95" color="danger-gradient" thin />
  <small class="small text-body-secondary">243GB/256GB</small>
  <div class="text-uppercase small fw-semibold mb-1 mt-2">
    SSD 2 Usage
  </div>
  <c-progress [value]="10" color="success-gradient" thin />
  <small class="small text-body-secondary">25GB/256GB</small>
</ng-template> -->
